export enum OrderPaymentStatusNameEnum {
	Open = 'Abierta',
	Closed = 'Cerrada',
}
